import styles from './ExamChangeInfoSharedStyling.module.scss'
import React, { ReactElement } from 'react'
import { ExamChangeInfoSharedProps } from '@/components/ExamChangeGuidePage/ExamChangeInfo/ExamChangeInfoSharedProps.types'
import { reusableCssClass } from '@/utils/reusableCssClasses'

export const Fall2023: React.FC<ExamChangeInfoSharedProps> = (
    _props
): ReactElement => {
    return (
        <div className={styles.examChangeGuideSharedComponent} id={'fall2023'}>
            <div className={styles.examChangeGuidePageTop}>
                <h2>Fall 2023</h2>
                <h3>Summary</h3>
                <div>
                    The SOA has released changes effective for the Fall 2023
                    sitting of FSA Group and Health Exams. The updated syllabi
                    can be found here:
                    <ul>
                        <li>
                            <a
                                href={
                                    'https://www.soa.org/499eac/globalassets/assets/files/edu/2023/fall/syllabi/ghdp.pdf'
                                }
                                target={'_blank'}
                                rel={'noreferrer'}
                                className={reusableCssClass.clickableText}
                            >
                                Design and Pricing
                            </a>
                            (Unchanged from Spring 2023)
                        </li>
                        <li>
                            <a
                                href={
                                    'https://www.soa.org/49287c/globalassets/assets/files/edu/2023/spring/syllabi/ghvru.pdf'
                                }
                                target={'_blank'}
                                rel={'noreferrer'}
                                className={reusableCssClass.clickableText}
                            >
                                Valuation and Regulation
                            </a>
                        </li>
                        <li>
                            <a
                                href={
                                    'https://www.soa.org/499cba/globalassets/assets/files/edu/2023/fall/syllabi/ghrm.pdf'
                                }
                                target={'_blank'}
                                rel={'noreferrer'}
                                className={reusableCssClass.clickableText}
                            >
                                Risk Mitigation
                            </a>
                            (Unchanged from Spring 2023)
                        </li>
                    </ul>
                    GHDP and GHRM remain the same. GHVR has the following
                    changes:
                    <ul>
                        <li>
                            2 study notes added in the Financial Statements
                            section (both relatively short)
                        </li>
                        <li>
                            1 study note removed from the Regulation & Taxation
                            section (medium length)
                        </li>
                        <li>
                            1 study note modified in the Regulation & Taxation
                            section (2 examples removed)
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
